export enum Inovae2OStylesOverviewTestLabelEnum {
  MATERIAL_GROUP_LBL = 'material-group-lbl',
  MATERIAL_NOTES_LBL = 'material-notes-lbl',
}
